import { v4 as uuidv4 } from 'uuid'

export const destinationCodes = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: 'Destination Code ' + ++index,
  description: 'Description ' + index,
  __typename: 'DestinationCode'
}))
